<script lang="ts" setup>
import { computed, useSlots, type VNode } from 'vue';
import useTransitionBase from '../VTransitionBase/composables/transitionBase';
import type { Props } from '../VTransitionBase/types';
import { propsDefaults } from '../VTransitionBase/utils';

const props = withDefaults(defineProps<Props>(), propsDefaults);

const { classAttributes } = useTransitionBase(() => props);

const slots = useSlots();
const slotChildren = computed(() => {
  if (!slots.default) return [];

  const defaultSlots = slots.default();
  if (!Array.isArray(defaultSlots) || defaultSlots.length === 0) return [];

  return defaultSlots.map(({ children }) => children).flat() as VNode[];
});
</script>

<template>
  <TransitionGroup v-bind="classAttributes">
    <div v-for="component in slotChildren" :key="component.key ?? undefined">
      <div>
        <Component :is="component" />
      </div>
    </div>
  </TransitionGroup>
</template>
